<template>
    <div style="height:600px; width:800px">
        <l-map ref="map"
               :max-zoom="19"
               :useGlobalLeaflet="true"
               :zoomAnimation="true"
               v-model:zoom="zoom"
               v-model:center="center"
               :options="{
zoomControl:false
                }"
               @ready="onLeafletReady"
               @dragend="onDragEnd"
        >
            <l-tile-layer
                v-for="tileProvider in tileProviders"
                :key="tileProvider.name"
                :name="tileProvider.name"
                :visible="tileProvider.visible"
                :url="tileProvider.url"
                :attribution="tileProvider.attribution"
                layer-type="base"
            />
            <l-control-zoom position="bottomright"/>


        </l-map>
    </div>
</template>

<script>
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import {LMap, LTileLayer, LMarker, LTooltip, LControlZoom, LControlLayers} from "@vue-leaflet/vue-leaflet";
import "leaflet.markercluster/dist/leaflet.markercluster.js";

import { MarkerClusterGroup } from 'leaflet.markercluster'

export default {
    name: "LeafletMap.vue",
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LTooltip,
        LControlZoom,
        LControlLayers,
    },

    data() {
        return {
            zoom: 2,
            center: [20, 15],
            tileProviders: [
                // {
                //     name: "Street",
                //     visible: false,
                //     attribution:
                //         '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                //     url:
                //         "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw",
                //     id: "mapbox/streets-v11",
                // },
                // {
                //     name: "Grayscale",
                //     visible: true,
                //     attribution:
                //         '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                //     url:
                //         "https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw",
                // },
                {
                    name: "Darkmode",
                    visible: true,
                    attribution:
                        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                    url:
                        "https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoibm9tYWRpY21lZGlhIiwiYSI6ImNsaHFkcDIwOTJmbTAzbnFwdHRvd25hNXkifQ.aJWmmqntxq4TDNo7xUgkuA",
                },
            ],

            leafletReady: false,
            leafletObject: null,
        };
    },
    props: {
        nodes: {
            type: Array,
            default: () => [],
        }
    },
    mounted() {
        let nodes = this.nodes
        L.Map.addInitHook(function () {
          /*  const markerCluster = MarkerClusterGroup({
                removeOutsideVisibleBounds: true,
                chunkedLoading: true,
            }).addTo(this);
            console.log('marketclusr',markerCluster)

            let markers = [];
            for (let i = 0; i < nodes.length; i++) {
                const marker = L.marker(
                    L.latLng(nodes[i].latLng[0], nodes[i].latLng[1]),
                    {
                        title: nodes[i].name || 'unknown',
                    }
                );
                // marker.bindPopup("Number " + i);
                markers.push(marker);
            }

            markerCluster.addLayers(markers);

            console.log(markers, markerCluster)*/
        }.bind(nodes));

        // console.log('mounted')
        // console.log(this.nodes)
    },

    methods: {
        async onLeafletReady(map) {
            await this.$nextTick();
            this.leafletReady = true;
            this.siteMarkersGroup = new MarkerClusterGroup({
                removeOutsideVisibleBounds: true,
                chunkedLoading: true,
            })
            this.$refs.map.leafletObject.addLayer(this.siteMarkersGroup)
            await this.$nextTick()
            // `sites` is an array of objects with some coordinates.
            this.siteMarkersGroup.addLayers(this.nodes.map(s => {
                const options = { title: s.name, clickable: true, draggable: false }
                return L.marker(s.latLng) //.bindPopup(this.funcBuildingHTMLStringForPopup(s))
            }))
        },
        onDragEnd(data) {
            console.log('dragend', data)
        },
    },
};
</script>

<style scoped>

</style>
